<template>
  <div class="container-arcada-inferior">
    <div class="container-quadrante" :class="{ 'modo-quarto-quadrante': visualizarQuadrantes }">
      <div class="sub-container-arcada">
        <div v-for="denteQuartoQuadrante in dentesQuadrante4" :key="denteQuartoQuadrante.id"
             :id="'dente-' + denteQuartoQuadrante.id"
             class="dente-item container-quarto-quadrante"
             @click="selecionarDente(denteQuartoQuadrante)"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <odontograma-dente :imagem="denteQuartoQuadrante.foto"
                                   :possui-procedimentos="denteQuartoQuadrante.possuiProcedimentos"
                                   :possui-canal="denteQuartoQuadrante.possuiCanal"
                                   :foi-extraido="denteQuartoQuadrante.foiExtraido"
                                   :possui-restauracao="denteQuartoQuadrante.possuiRestauracao"
                />
                <span>{{ denteQuartoQuadrante.numero }}</span>
              </div>
            </template>
            {{ denteQuartoQuadrante.nome }}
          </v-tooltip>
        </div>
      </div>
      <label v-if="visualizarQuadrantes">Quadrante 4</label>
    </div>

    <div class="container-quadrante" :class="{ 'modo-terceiro-quadrante': visualizarQuadrantes }">
      <div class="sub-container-arcada">
        <div v-for="denteTerceiroQuadrante in dentesQuadrante3" :key="denteTerceiroQuadrante.id"
             :id="'dente-' + denteTerceiroQuadrante.id"
             class="dente-item container-terceiro-quadrante"
             @click="selecionarDente(denteTerceiroQuadrante)"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <odontograma-dente :imagem="denteTerceiroQuadrante.foto"
                                   :possui-procedimentos="denteTerceiroQuadrante.possuiProcedimentos"
                                   :possui-canal="denteTerceiroQuadrante.possuiCanal"
                                   :foi-extraido="denteTerceiroQuadrante.foiExtraido"
                                   :possui-restauracao="denteTerceiroQuadrante.possuiRestauracao"
                />
                <span>{{ denteTerceiroQuadrante.numero }}</span>
              </div>
            </template>
            {{ denteTerceiroQuadrante.nome }}
          </v-tooltip>
        </div>
      </div>
      <label v-if="visualizarQuadrantes">Quadrante 3</label>
    </div>
  </div>
</template>

<script>
import OdontogramaDente from '@/views/pages/cadastros/paciente/comum/odontograma/OdontogramaDente.vue'

export default {
    components: {OdontogramaDente},
    nome: 'OdontogramaArcadaInferior',
    props: {
        visualizarQuadrantes: {
            type: Boolean,
            default: false
        },
        dentesQuadrante3: {
            type: Array,
            required: true
        },
        dentesQuadrante4: {
            type: Array,
            required: true
        },
    },
    data() {
        return {}
    },
    methods: {
        selecionarDente(dente) {
            this.$emit('selecionarDenteEvento', dente)
        }
    }
}
</script>

<style scoped lang="stylus">

.container-arcada-inferior
  display flex
  flex-direction row
  justify-content center

.sub-container-arcada
  display flex
  flex-direction row
  justify-content center

.container-quarto-quadrante, .container-terceiro-quadrante
  text-align center

.dente-item:hover
  cursor pointer
  opacity 0.7

.container-quadrante
  text-align center

.modo-quarto-quadrante
  background-color #AF929D

.modo-terceiro-quadrante
  background-color #D2D6EF
  border-left 1px solid black


</style>